export type ColorMapping = {
  maxTemperatur: number;
  minTemperatur: number;
  color: string;
};

export const colorMappings: ColorMapping[] = [
  {
    maxTemperatur: 3,
    minTemperatur: -Infinity,
    color: 'text-primary-blue-B400',
  },
  {
    maxTemperatur: 10,
    minTemperatur: 4,
    color: 'text-primary-blue-B600',
  },
  {
    maxTemperatur: 20,
    minTemperatur: 11,
    color: 'text-primary-orange-O400',
  },
  {
    maxTemperatur: 30,
    minTemperatur: 21,
    color: 'text-primary-orange-O500',
  },
  {
    maxTemperatur: Infinity,
    minTemperatur: 31,
    color: 'text-primary-red-R500',
  },
];
